import { ILogService } from '../../interfaces/scheduler_interfaces';
import { IDefineCommand, IQuery } from 'core-ts-types';
import { ISchedulerStudentPlanDatasource } from '../datasource/student_plans_datasource';
import { SchedulerStudentPlan } from '../builders/scheduler_student_plan';

import { BackToPlannerHelper } from '../../components/back_to_planner/helpers/back_to_planner_helper';
interface IStudentPlanAPIResponse {
  data: SchedulerStudentPlan[];
}

export type FetchStudentActivePlanDetailsCommand = () => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'fetchStudentActivePlanDetailsCommand',
    (
      defineCommandORM: IDefineCommand,
      $http: ng.IHttpService,
      log: ILogService,
      ngSchedulerStudentPlanDatasource: ISchedulerStudentPlanDatasource,
      ngBackToPlannerHelper: BackToPlannerHelper
    ) =>
      defineCommandORM('fetchStudentActivePlanDetailsCommand', (deferred) => {
        const isAP1Enabled = ngBackToPlannerHelper.isAP1PlannerEnabled();
        if (isAP1Enabled) {
          return deferred.resolve();
        }
        return $http
          .get('ap3/studentplans/?is_primary=true')
          .then(({ data }) => {
            ngSchedulerStudentPlanDatasource.clear().write((data as IStudentPlanAPIResponse).data);
            deferred.resolve();
          })
          .catch((e) => {
            log.issue('Unable to fetch student plan details');
            deferred.reject(e);
          });
      })
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/search_and_add_courses/commands/fetch_student_active_plan_details_command.ts